// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  JournalHistoryPage,
} from "./types";

export const params = {
  from: __t.timestamp(),
  to: __t.timestamp(),
  actor: __t.option(__t.identity()),
  limit: __t.u32(),
  offset: __t.u32(),
};
export const returnType = JournalHistoryPage